import type {
  CapabilitySessionErrorUnion,
  CapabilitySessionWriteErrorUnion,
} from '../capabilityError';
import { makeSessionCapabilityErrors } from '../capabilityError';

/**
 * What `CustomerAccount` reports when an operation does not answer.
 *
 * The `Unauthorized` arm is the one that shapes every account page. A read of
 * `/customers/me` with no bearer token answers
 * `401 {"code":401,"message":"JWT Token not found"}`, measured on 2026-09-08,
 * and the page for that is the sign-in prompt rather than a failure notice —
 * which is exactly the distinction a session guard needs and `Unavailable`
 * cannot make.
 *
 * {@link CustomerAccountError} types the reads and
 * {@link CustomerAccountWriteError} the writes, so a page that only shows a
 * profile handles four arms and one that edits it handles five.
 */
export const CustomerAccountError = makeSessionCapabilityErrors('CustomerAccount');

export type CustomerAccountError = CapabilitySessionErrorUnion<typeof CustomerAccountError>;

export type CustomerAccountWriteError = CapabilitySessionWriteErrorUnion<
  typeof CustomerAccountError
>;
